module.exports = __webpack_public_path__ + "images/Health_Catalyst-f42d6f.png";